import {
  Component,
  EventEmitter,
  Input,
  Output,
} from '@angular/core';
import { Subject } from 'rxjs';

//#DECLARACION FUNCIONES TOPAZ
declare function StartSign(): any;
declare function getData(): any;
declare function clearData(): any;
//#DECLARACION FUNCIONES TOPAZ

@Component({
  selector: 'app-topaz',
  templateUrl: './topaz.component.html',
  styleUrls: ['./topaz.component.scss']
})
export class TopazComponent {

  private _destroy$: Subject<boolean> = new Subject<boolean>();
  @Output() closeModal = new EventEmitter<any>();
  @Output() datosFirma = new EventEmitter<{ firmaB64: string, firmaSigString: string }>();
  @Input() nombreTrabajador : string;
  @Input() nombreEstudio : string;  
  messagesErrorPrevious;
  signedData;

  private _displayModalFirma = true;

  constructor() {}

  callSignatureModal(){
    StartSign();
  }

  getSignedData(){
    this.signedData = getData();
  }

  onDone(){
    this.getSignedData();
    if(this.signedData.img64 != undefined || this.signedData.sigString != undefined){
      this.enviarFirma(this.signedData.img64, this.signedData.sigString);
      this.closeModalFirma();
    }else{
      this.messagesErrorPrevious = [{ severity: 'error', summary: 'Error', detail: 'Debe realizar la firma para continuar.'}];
    }
  }

  closeModalFirma(){
    try{
      this._displayModalFirma = false;
      this.closeModal.emit(false);
      clearData();
    }catch(err){
      console.log(err)
    }
  }

  get displayModalFirma() {
    return this._displayModalFirma;
  }

  @Input()
  set displayModalFirma(val) {
    this._displayModalFirma = val;
  }

  enviarFirma(firma: string, sigString: string) {
    const datosFirma = { firmaB64: firma, firmaSigString: sigString };
    this.datosFirma.emit(datosFirma);
  }
}
